import { render, staticRenderFns } from "./listTips.vue?vue&type=template&id=6f2b1772&"
import script from "./listTips.vue?vue&type=script&lang=js&"
export * from "./listTips.vue?vue&type=script&lang=js&"
import style0 from "./listTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports